export default "__VITE_ASSET__DyydXqTE__"